/* eslint-disable */
import React, { useEffect, useState } from 'react';
import ErrorModal from '.';
import { useAppContext } from '../../context/appContext';
import ACTIONS from '../../context/appActions';

const WithErrorDialog = (ScreenComponent) => {
  const WithStateComponent = (props) => {
    const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
    const { dispatch } = useAppContext();
    // eslint-disable-next-line
    useEffect(() => {
      setIsOpenErrorModal(props.store.hasError);
    }, [props.store.hasError]);

    const toggleModal = () => {
      dispatch({ type: ACTIONS.UPDATE_STATE, data: { hasError: false } })
      setIsOpenErrorModal(!isOpenErrorModal)
    };

    return (
      <>
        <ScreenComponent {...props} setIsOpenErrorModal={setIsOpenErrorModal} />
        <ErrorModal isOpen={isOpenErrorModal} toggle={toggleModal} />
      </>
    );
  };

  return WithStateComponent;
};

export default WithErrorDialog;
/* eslint-enable */
